import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-video.svg
 */
const IconTypeVideo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M4.636 3.272A4.637 4.637 0 000 7.908v8.184a4.635 4.635 0 004.636 4.636h14.728A4.637 4.637 0 0024 16.092V7.908a4.635 4.635 0 00-4.636-4.636H4.636zm0 1.635h14.728a2.997 2.997 0 012.997 2.998v8.182a2.999 2.999 0 01-2.997 2.998H4.636a3.002 3.002 0 01-3-2.998V7.905a3.001 3.001 0 013-2.998zm5.455 5.045v4.09a.855.855 0 001.292.734l3.46-2.043a.86.86 0 000-1.474l-3.46-2.046a.859.859 0 00-1.292.739z"
      fill="currentColor"
    />
  </svg>
);

export default IconTypeVideo;
